import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const EducationRoutes: RouteObject = {
	path: "/elearning/*",
	children: [
		{
			index: true,
			lazy: async () => {
				const { EducationHome } = await import(
					"@/components/Education/EducationHome"
				);
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<EducationHome />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: "courses",
			lazy: async () => {
				const { Courses } = await import("@/components/Education/Courses");
				return {
					Component: Courses,
				};
			},
		},
		{
			path: "courses/:courseId",
			lazy: async () => {
				const { CourseDetails } = await import(
					"@/components/Education/CourseDetails"
				);
				return {
					Component: CourseDetails,
				};
			},
		},
	],
};
